const NotSignedIn = () => {
  window.adobeIMS.signIn() 
  return <div></div>
};

export default NotSignedIn;
